import { defineStore, acceptHMRUpdate } from "pinia";

export const useUtilityStore = defineStore({
  id: "utility",
  state: () => {
    return { isOnline: navigator.onLine };
  },
  actions: {
    setupOfflineListeners() {
      window.addEventListener("offline", (e) => {
        this.isOnline = false;
        console.log("Browser is now offline");
      });
      window.addEventListener("online", (e) => {
        this.isOnline = true;
        console.log("Browser is now online");
      });
      this.isOnline = navigator.onLine;
    },
  },
  getters: {},
});

//Enable Hot Module Replacement
// https://pinia.esm.dev/cookbook/hot-module-replacement.html
if ((import.meta as any).hot) {
  (import.meta as any).hot.accept(acceptHMRUpdate(useUtilityStore as any, (import.meta as any).hot));
}
